import React from 'react';
import { Form, Input, Tag, Button, Spin, Icon, Tooltip, Progress, Switch } from 'antd';
import Avatar from './imageupload';
import VideoUpload from './videoupload';
import EditableItem from './editable';
import AddItem from './additem';

const { TextArea } = Input;
const antIcon = progress => (
  <Progress
    type="circle"
    percent={progress}
    format={() => (progress === 100 ? 'Done' : `${progress}%`)}
    width={80}
  />
);

export default ({
  media,uploadMedia,
  refreshVideos,refresh,
  profile,getMedia,
  handleSubmit,
  handleInputChange,
  handleClose,
  saveInputRef,
  handleInputConfirm,
  showInput,
  handleImageChange,
  progress,
  handleVideoChange,
  getFieldDecorator,
  handleSaveEditable,
  loading,
  normFile,
  setFieldsValue,
  showRequirementInput,
  showYouWillLearnInput,
  handleAddRequirement,
  handleAddYouWillLearn,
  handleCancelYouWillLearn,
  handleAddRequirementInput,
  handleAddYouWillLearnInput,
  handleCancelRequirement,
  requirements,
  tagName,
  tags,
  inputVisible,
  youWillLearn,
  handleSubmitAsDraft,
  handleNewCourse
}) => (
  <Spin indicator={antIcon(progress)} spinning={loading}>
    <Form onSubmit={handleSubmit} className="course-form">
      <Form.Item label="Course Title">
        {getFieldDecorator('title', {
          rules: [{ required: true, message: 'Please input course title' }]
        })(
          <Input
            name="title"
            onChange={handleInputChange}
            placeholder="Course Title"
          />
        )}
      </Form.Item>

      <Form.Item label="Course Subtitle">
        {getFieldDecorator('subtitle', {
          rules: [{ required: true, message: 'Please input course subtitle' }]
        })(
          <Input
            name="subTitle"
            onChange={handleInputChange}
            placeholder="Course Subtitle"
          />
        )}
      </Form.Item>

      <Form.Item label="Course Description">
        {getFieldDecorator('description', {
          rules: [
            { required: true, message: 'Please input course description' }
          ]
        })(
          <TextArea name="description" onChange={handleInputChange} rows={4} />
        )}
      </Form.Item>

      <Form.Item label="Course Tags">
        <div>
          {tags.map((tag) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag key={tag} closable onClose={() => handleClose(tag)}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          {inputVisible && (
            <Input
              ref={saveInputRef}
              type="text"
              size="small"
              style={{ width: 200 }}
              name="tagName"
              value={tagName}
              onChange={handleInputChange}
              onBlur={handleInputConfirm}
              onPressEnter={handleInputConfirm}
            />
          )}
          {!inputVisible && (
            <Tag
              onClick={showInput}
              style={{ background: '#fff', borderStyle: 'dashed' }}
            >
              <Icon type="plus" /> New Tag
            </Tag>
          )}
        </div>
      </Form.Item>

      <Form.Item label="Course Image">
        <Avatar
          setFieldsValue={setFieldsValue}
        profile={profile}
        normFile={normFile}
          getFieldDecorator={getFieldDecorator}
          handleImageChange={handleImageChange}
        />
      </Form.Item>

      <Form.Item label="Course Promotional Video">
        <VideoUpload
          media={media}
        uploadMedia={uploadMedia}
        refreshVideos={refreshVideos}
        refresh={refresh}
        getMedia={getMedia}
        profile={profile}
          getFieldDecorator={getFieldDecorator}
          handleVideoChange={handleVideoChange}
        />
      </Form.Item>

      <Form.Item label="Course Requirements" className="level-label">
        <div style={{ textAlign: 'right', height: 15 }}>
          <Button
            style={{ bottom: 28 }}
            onClick={() => handleAddRequirementInput()}
            size="small"
            ghost
            type="primary"
            icon="plus"
          >
            Add
          </Button>
        </div>
        {showRequirementInput ? (
          <AddItem
            name="requirement"
            handleAddItem={handleAddRequirement}
            handleCancelItem={handleCancelRequirement}
          />
        ) : (
          ''
        )}
        <EditableItem
          name="requirements"
          items={requirements}
          handleSaveEditable={handleSaveEditable}
        />
      </Form.Item>

      <Form.Item label="What you will learn" className="level-label">
        <div style={{ textAlign: 'right', height: 15 }}>
          <Button
            style={{ bottom: 28 }}
            onClick={() => handleAddYouWillLearnInput()}
            size="small"
            ghost
            type="primary"
            icon="plus"
          >
            Add
          </Button>
        </div>
        {showYouWillLearnInput ? (
          <AddItem
            name="youWillLearn"
            handleAddItem={handleAddYouWillLearn}
            handleCancelItem={handleCancelYouWillLearn}
          />
        ) : (
          ''
        )}
        <EditableItem
          name="youWillLearn"
          items={youWillLearn}
          handleSaveEditable={handleSaveEditable}
        />
      </Form.Item>

      <Form.Item label="Set as new course" className="switch-item">
        <Switch className="switch-control" defaultChecked onChange={handleNewCourse}/>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Publish
        </Button>
        <Button className="draft-btn" onClick={handleSubmitAsDraft}>
          Save as Draft
        </Button>
      </Form.Item>
    </Form>
  </Spin>
);
